import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { ETIQUETA_ENTORNO } from './entorno';
import './estilos.css';

// Tras un despliegue, los archivos con hash de la versión anterior ya no existen: si falla la carga de uno,
// se recarga la página una vez para tomar el index.html nuevo (que el hosting sirve sin caché).
window.addEventListener('vite:preloadError', (ev) => {
  const clave = 'estiba:recarga';
  const ultima = Number(sessionStorage.getItem(clave) ?? 0);
  if (Date.now() - ultima < 60_000) return;
  ev.preventDefault();
  sessionStorage.setItem(clave, String(Date.now()));
  location.reload();
});

// Etapa 10: la vista pública del roadmap (/r/:token) no tiene sesión ni carga la aplicación (ni Firebase).
const App = lazy(() => import('./App').then((m) => ({ default: m.App })));
const RoadmapPublico = lazy(() => import('./publico/RoadmapPublico').then((m) => ({ default: m.RoadmapPublico })));
const publico = /^\/r\/[^/]+\/?$/.test(location.pathname);
// Fuera de producción, la pestaña dice en qué entorno está (el roadmap público pone su propio título).
if (ETIQUETA_ENTORNO && !publico) document.title = `[${ETIQUETA_ENTORNO}] Estiba`;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={null}>{publico ? <RoadmapPublico /> : <App />}</Suspense>
  </StrictMode>,
);
